import { useTranslation } from 'react-i18next';

import { ModalShell } from '../../../../components';

/**
 * 공유 전 고지 — 기록이 링크를 가진 누구에게나 열린다는 것을 매번 말한다("다시 보지 않기" 없음).
 * 기본 포커스는 취소다 — 실수로 엔터를 눌러 공개되지 않게.
 */
export const ShareConfirmDialog = ({
  onConfirm,
  onCancel,
}: {
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <ModalShell
      labelledBy="result-share-confirm-title"
      dismissLabel={t('web.result.share.cancel')}
      onDismiss={onCancel}
      className="px-5 pb-5 pt-8"
    >
      <h2
        id="result-share-confirm-title"
        className="text-lg font-semibold tracking-[-0.18px] text-bk-900"
      >
        {t('web.result.share.confirmTitle')}
      </h2>
      <p className="mt-2 whitespace-pre-line break-keep text-sm leading-relaxed text-bk-600">
        {t('web.result.share.confirmBody')}
      </p>
      <div className="mt-6 flex gap-2">
        <button
          type="button"
          onClick={onConfirm}
          className="h-[54px] flex-1 rounded-full border border-bk-300 bg-white text-base font-semibold text-bk-900"
        >
          {t('web.result.share.confirm')}
        </button>
        <button
          type="button"
          autoFocus
          onClick={onCancel}
          className="h-[54px] flex-1 rounded-full bg-bk-900 text-base font-semibold text-white"
        >
          {t('web.result.share.cancel')}
        </button>
      </div>
    </ModalShell>
  );
};
